import { cardsItems, carouselItems } from '@/mocks/homeData';

export function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            深度爆料
          </h2>
          <p className="text-[14px] text-foreground-500">独家调查与深度分析，还原事件真相</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group block bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all no-underline"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[11px] font-semibold bg-primary-500 text-background-50 rounded">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-[15px] md:text-[16px] font-bold text-foreground-900 group-hover:text-primary-700 transition-colors leading-snug mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-[13px] text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.excerpt}
                </p>
                <span className="text-[12px] text-foreground-400">{item.date}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            焦点专题
          </h2>
          <p className="text-[14px] text-foreground-500">精选深度专题，全方位解析最热事件</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group relative block rounded-lg overflow-hidden no-underline"
            >
              <div className="relative aspect-[16/9] md:aspect-[21/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 text-[11px] font-semibold bg-accent-500 text-background-50 rounded mb-3">
                  {item.tag}
                </span>
                <h3 className="text-[18px] md:text-[20px] font-black text-background-50 font-heading mb-1 group-hover:text-accent-300 transition-colors">
                  {item.title}
                </h3>
                <p className="text-[12px] text-background-400 mb-2">{item.subtitle}</p>
                <p className="text-[13px] text-background-300 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}